export default "/images/logo.png?dccc6259ab8aef6c10f6f3e23b2a587f";